import React, { useState, useEffect } from "react";
import { useSubheader } from "../../../../_metronic/layout";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, {
  PaginationProvider,
} from "react-bootstrap-table2-paginator";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import * as actions from "./_redux/Actions";
import { Pagination } from "../../../../_metronic/_partials/controls";
import * as columnFormatters from "../../../components/column-formatters";
import * as UIHelpers from "../../../components/UIHelpers";
import { Formik, Field } from "formik";
import {
  NotificationManager,
  NotificationContainer,
} from "react-notifications";
import DropdownReactSelect from "../../../components/DropdownReactSelect";
import FilterComponent from "../../../components/FilterComponent";
import {
  NoRecordsFoundMessage,
  PleaseWaitMessage,
  sortCaret,
  headerSortingClasses,
} from "../../../../_metronic/_helpers";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../../_metronic/_partials/controls";
import helperFunc from "../../../../_metronic/_helpers/helperFunc";

import moment from "moment";

export const initialFilter = {
  filter: {},
  sort: "desc",
  sortBy: "createdAt",
  skip: UIHelpers.skip,
  limit: UIHelpers.limit,
  page: UIHelpers.page,
};

const ListComponent = (props) => {
  const dispatch = useDispatch();
  const suhbeader = useSubheader();
  const [filter, setFilter] = useState(initialFilter);
  const [count, setCount] = useState(0);
  const [searchApply, setSearchApply] = useState(false);
  const [
    contestForSelectedDropdownFilterData,
    setContestForListDropdownFilterData,
  ] = useState([]);
  const [
    contestForDropdownFilterData,
    setContestForDropdownFilterData,
  ] = useState([]);

  useEffect(() => {
if(count!==0){
  dispatch(actions.fetchAPKScreenList(filter))
}
   
  }, [filter,count]);

  suhbeader.setTitle("APK Screens");
  const newItem = () => {
    if (helperFunc.isButtonAccess("master.apkScreen.add", "add")) {
      props.history.push("/apkscreen/create");
    } else {
      NotificationManager.error("Access denied.", "Error");
    }
  };
  const editItem = (id) => {
    if (helperFunc.isButtonAccess("master.apkScreen.add", "add")) {
      props.history.push(`/apkscreen/edit/${id}`);
    } else {
      NotificationManager.error("Access denied.", "Error");
    }
  };

  const getHandlerTableChange = (type, data) => {
    if (type === "pagination") {
        filter.limit = data.sizePerPage;
        filter.skip = Math.abs(data.page ? data.sizePerPage - data.page * data.sizePerPage : 0);
        filter.page = data.page || 1;
        setFilter(filter);
        setCount(count + 1);
        
        // Call the API here
        if (!listLoading) {
            localStorage.setItem("selectedCompanyy", contestForSelectedDropdownFilterData.code);
            dispatch(actions.fetchList(filter));
        }
    }
    if (type === "sort") {
        filter.sort = data.sortOrder;
        filter.sortBy = data.sortField;
        setFilter(filter);
        setCount(count + 1);
        
        // Call the API here
        if (!listLoading) {
            localStorage.setItem("selectedCompanyy", contestForSelectedDropdownFilterData.code);
            dispatch(actions.fetchList(filter));
        }
    }
}

const filterChange = (filterData) => {
    filter.q = filterData.q;
    filter.filter = filterData.filter;
    setFilter(filter);
    setCount(count + 1);
}

//   const statusChange = (data) => {
//     const params = {...data} ;
//     params.isActive = !params.isActive;
//     dispatch(actions.updateItem(params)).then((sucess) => sucess ? setCount(count+1) : null);
// }
const statusChange = (data) => {
  const params = { ...data };
  params.isActive = !params.isActive;
  dispatch(actions.updateItem(params)).then((sucess) =>
   setCount(count + 1)
  );
};
  const columns = [
    {
      dataField: "name",
      text: "Name",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      dataField: "code",
      text: "Code",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      dataField: "isGamerjiAds",
      text: "Is Gamerji Ads",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      formatter: columnFormatters.TrueFalseColumnFormatter,
    },
    {
      dataField: "isFbAds",
      text: "Is Facebook Ads",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      formatter: columnFormatters.TrueFalseColumnFormatter,
    },
    {
      dataField: "createdAt",
      text: "CreatedAt",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      formatter: columnFormatters.DateColumnFormatter,
    },
    {
      dataField: "isActive",
      text: "IsActive",
      sort: false,
      sortCaret: sortCaret,
      headerSortingClasses,
      formatter: columnFormatters.StatusColumnFormatter,
      formatExtraData: {
        statusChange: helperFunc.isButtonAccess("master.apkScreen.update", "update")
          ? statusChange
          : null,
      },
    },
    {
      dataField: "action",
      text: "Actions",
      formatter: columnFormatters.ActionsColumnFormatter,
      formatExtraData: {
        editItem:
          helperFunc.isButtonAccess("master.apkScreen.add", "add")
            ? editItem
            : null,
      },
      classes: "text-right pr-0",
      headerClasses: "text-right pr-3",
      style: {
        minWidth: "100px",
      },
    },
  ];

  const { currentState } = useSelector(
    (state) => ({ currentState: state.apkScreenList }),
    shallowEqual
  );
  const {
    totalCount,
    entities,
    listLoading,
    companyDropdownList,
  } = currentState;
  useEffect(() => {
    dispatch(actions.fetchCompanyDropdownList());
  }, []);
  useEffect(() => {
    if (companyDropdownList && companyDropdownList?.data) {
      let temp = [];
      const userdata = JSON.parse(localStorage.getItem("userData"));
      const userCompany = userdata?.company || [];
      companyDropdownList.data.forEach((element, i) => {
          if (userCompany.includes(element._id)) {
            temp.push({
              _id: i + 1,
              label: element.name,
              value: element._id,
              code: element.code,
              "data-tokens": element.name,
            });
          }
      });
      setContestForDropdownFilterData(temp);
    }
  }, [companyDropdownList]);
  const applyFilter = async (values) => {
    if (
      contestForSelectedDropdownFilterData == null ||
      contestForSelectedDropdownFilterData.length <= 0
    ) {
      // This block is executed if contestForSelectedDropdownFilterData is null or empty.
      NotificationManager.error("Please Select Company", "Error");
      return false;
    }

    setSearchApply(true);
    var tampFilter = { ...filter };
    console.log(
      "contestForSelectedDropdownFilterData1",
      contestForSelectedDropdownFilterData
    );
    tampFilter.company = contestForSelectedDropdownFilterData.code;
    if (values?.phoneEmail) {
      tampFilter.search = {
        userID: values.phoneEmail,
      };
    }
    let selectedFields = [];

    // Add the logic to update the selectedFields array with the selected fields

    setFilter(tampFilter);

    console.log("tampFilter", tampFilter);

    if (!listLoading) {
      // dispatch(actions.fetchStaffUsers(tampFilter));

      localStorage.setItem(
        "selectedCompanyy",
        contestForSelectedDropdownFilterData.code
      );
      dispatch(actions.fetchList(tampFilter));
    }
  };

 
  
  // Table pagination properties
  const paginationOptions = {
    custom: true,
    totalSize: totalCount,
    sizePerPageList: UIHelpers.sizePerPageList,
    sizePerPage: filter.limit,
    page: filter.page,
  };

  const createFormInputs = () => {
    return (
      <div className="w-100" style={{ padding: "0px 0", margin: "0px" }}>
        <Formik
          initialValues={{}}
          onSubmit={(values) => {
            console.log("val::22", values);
            applyFilter(values);
          }}
        >
          {({ handleSubmit, values }) => (
             <div className="">
              {/* <div className="row m-0 p-0"> */}
              <form
                onSubmit={handleSubmit}
                className="form form-filter w-100"
                autoComplete="off"
                // style={{ marginTop: "25px" }}
              >
                 <div className="form-group row m-0 align-items-center z-index: 10">
                  <div
                    className="col-md-66  col-lg-3 z-index: 10 !important pb-3 pl-0"
                    // style={{ maxWidth: "325px" }}
                  >
                    <label>Select Company</label>
                    <DropdownReactSelect
                      placeholder={"Company"}
                      name={"Company"}
                      value={contestForSelectedDropdownFilterData}
                      // isMulti={values.isShared == 'true' ? true : false}
                      isMulti={false}
                      isClearable={true}
                      isSearchable={true}
                      closeMenuOnSelect={true}
                      options={contestForDropdownFilterData}
                      onChange={setContestForListDropdownFilterData}
                    />
                  </div>

                  <div className="justify-content-end mx-2 pb-2">
                    <button
                      type="submit"
                      className="btn btn-dark"
                      style={{ width: "130px", marginTop: "20px" }}
                    >
                      Search
                    </button>
                  </div>
                </div>
              </form>
              {/* </div> */}
            </div>
          )}
        </Formik>
      </div>
    );
  };
  return (
    <>
      <NotificationContainer />
      <Card>
        <CardHeader title="APK Screen list">
          <CardHeaderToolbar>
            <div
              className="d-flex align-items-center mr-3"
              style={{ position: "relative", top: "3px" }}
            >
              {helperFunc.isButtonAccess("master.apkScreen.add", "add") && (
                <button
                  type="button"
                  className="btn btn-dark"
                  onClick={newItem}
                >
                  Add New Screen
                </button>
              )}
            </div>
          </CardHeaderToolbar>
        </CardHeader>
        <div className="card-header">
          <div className="my-5 w-100 mt-9 row mx-auto">
            {createFormInputs()}
          </div>
        </div>

        {searchApply === true ? ( // searchApply === true
          entities?.length == 0 && listLoading === false ? (
            UIHelpers.dataTableNoData()
          ) : (
            <CardBody>
            <FilterComponent filterChange={filterChange} />
            <PaginationProvider pagination={paginationFactory(paginationOptions)}>
                {({ paginationProps, paginationTableProps }) => {
                    return (
                        <Pagination
                            isLoading={listLoading}
                            paginationProps={paginationProps}
                        >
                            <BootstrapTable
                                wrapperClasses="table-responsive"
                                bordered={false}
                                classes="table table-head-custom table-vertical-center overflow-hidden"
                                bootstrap4
                                remote
                                keyField="_id"
                                data={entities ? entities : []}
                                columns={columns}
                                onTableChange={getHandlerTableChange}
                                {...props}
                                {...paginationTableProps}
                            >
                                <PleaseWaitMessage entities={entities} />
                                <NoRecordsFoundMessage entities={entities} />
                            </BootstrapTable>
                        </Pagination>
                    );
                }}
            </PaginationProvider>
        </CardBody>
          )
        ) : (
          // <h4 className="text-center">Please select search</h4>
          ""
        )}
      </Card>
    </>
  );
};
export default ListComponent;
